import React, { useState, useEffect } from 'react';
import Grid from '@material-ui/core/Grid';
import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import BiztranControls from "../../biztran_controls/BiztranControls";
import BiztranControlsFormik from "../../biztran_controls_formik/BiztranControlsFormik";
import UseFetchData from "../../../hooks/UseFetchData";

const CreateHotelStayPolicy = (props) => {
    const [HotelStayPolicyID, setHotelStayPolicyID] = useState('');
    const [CategoryID, setCategoryID] = useState('');
    const [HotelStarRatingID, setHotelStarRatingID] = useState('');
    const [UpperCeilingCapitalCities, setUpperCeilingCapitalCities] = useState('');
    const [UpperCeilingNonCapitalCities, setUpperCeilingNonCapitalCities] = useState('');
    const [Countrycmb, setCountrycmb] = useState([]);
    const [response, fetchData] = UseFetchData();
    const [responseCombo, fetchComboData] = UseFetchData();
    const [responseGetData, fetchGetData] = UseFetchData();
    const [Categorycmb, setCategorycmb] = useState([]);
    const [CategoryDataResponse, fetchCategoryData] = UseFetchData();
    const [HotelStarRatingcmb, setHotelStarRatingcmb] = useState([]);
    const [HotelStarRatingResponse, fetchHotelStarRating] = UseFetchData();

    // const validationSchema = Yup.object({
    //     CountryID:Yup.string().required('Required!'),
    //     StateName:Yup.string().required('Required!'),
    //     StateCode:Yup.string().required('Required!'),
    // });

    const onSubmit = values => {
        var bodyFormData = new FormData();
        bodyFormData.append("Type", 'Hotel Stay Policy');
        bodyFormData.append("PKID", props.PKID);
        bodyFormData.append("Value1", values.CategoryID);
        bodyFormData.append("Value2", values.HotelStarRatingID);
        bodyFormData.append("Value3", values.UpperCeilingCapitalCities);
        bodyFormData.append("Value4", values.UpperCeilingNonCapitalCities);
        fetchData("Primary/Save", bodyFormData);
    };

    const getByIDData = () => {
        var bodyFormData = new FormData();
        bodyFormData.append("Type", 'Hotel Stay Policy');
        bodyFormData.append("PKID", props.PKID);
        fetchGetData("Primary/GetByID", bodyFormData);
    }


    const PopulateCategorydata = () => {
        var bodyFormData = new FormData();
        fetchCategoryData("Primary/ComboData", bodyFormData);
    }
    const CategoryData = (options) => {
        debugger;
        if (options !== undefined) {
            let Category = options.map((data) => (
                <option key={data.Category} value={data.CategoryID}>
                    {data.Category}
                </option>
            ));
            setCategorycmb(Category);
        }
    };

    useEffect(() => {
        debugger;
        if (CategoryDataResponse !== undefined) {
            if (CategoryDataResponse["Category"] !== undefined) {
                CategoryData(CategoryDataResponse["Category"]);
            }
        }
    }, [CategoryDataResponse]);


    const HotelStarRating = () => {
        var bodyFormData = new FormData();
        fetchHotelStarRating("Primary/ComboData", bodyFormData);
    }
    const HotelStarRatingData = (options) => {
        debugger;
        if (options !== undefined) {
            let HotelStarRating = options.map((data) => (
                <option key={data.HotelStarRating} value={data.HotelStarRatingID}>
                    {data.HotelStarRating}
                </option>
            ));
            setHotelStarRatingcmb(HotelStarRating);
        }
    };

    useEffect(() => {
        debugger;
        if (HotelStarRatingResponse !== undefined) {
            if (HotelStarRatingResponse["HotelStarRating"] !== undefined) {
                HotelStarRatingData(HotelStarRatingResponse["HotelStarRating"]);
            }
        }
    }, [HotelStarRatingResponse]);

    useEffect(() => {
        PopulateCategorydata();
        HotelStarRating();
        // ModeOfTravelType();
    }, [])

    // const CountryData = () => {
    //     var bodyFormData = new FormData();
    //     bodyFormData.append("Type", 'Country');
    //     fetchComboData("Primary/List", bodyFormData);
    // }

    // const CountrydataOpt = (CountryOption) => {
    //     let CountryCombo = CountryOption.map((data) =>
    //         <option
    //             key={data.Country}
    //             value={data.id}
    //         >
    //             {data.Country}
    //         </option>
    //     );
    //     setCountrycmb(CountryCombo);
    // };

    useEffect(() => {
        if (response.Response === true) {
            props.setOpen(false);
            props.PopulateData();
            alert('Saved Succesfully.')
        }
        else if (response.Response === false) {
            alert('Save Failed.')
        }
    }, [response])

    // useEffect(() => {
    //     CountrydataOpt(responseCombo);
    // },[responseCombo])

    useEffect(() => {
        if (responseGetData.length > 0) {
            setHotelStarRatingID(responseGetData[0].HotelStarRatingID);
            setHotelStayPolicyID(responseGetData[0].HotelStayPolicyID);
            setCategoryID(responseGetData[0].CategoryID);
            setUpperCeilingCapitalCities(responseGetData[0].UpperCeilingCapitalCities);
            setUpperCeilingNonCapitalCities(responseGetData[0].UpperCeilingNonCapitalCities);
        }
    }, [responseGetData])

    useEffect(() => {
       // CountryData();
        if(props.PKID !== ''){
            getByIDData();
        }
    },[])

    return (
        <div>
            <Formik initialValues={{
                CategoryID: CategoryID, HotelStarRatingID: HotelStarRatingID, HotelStayPolicyID: HotelStayPolicyID,
                UpperCeilingCapitalCities: UpperCeilingCapitalCities, UpperCeilingNonCapitalCities: UpperCeilingNonCapitalCities
            }}
                // validationSchema = {validationSchema} 
                onSubmit={onSubmit} enableReinitialize>
                {formik => {
                    return <Form>
                        <Grid spacing={2} container>
                            {/* <Grid item xs={12}>
                                <BiztranControlsFormik 
                                    control='select' 
                                    label='Travelling Policy Type' 
                                    name='CountryID'
                                    options={Countrycmb} 
                                    onChange={(e) => setCountryID(e.target.value)}
                                />
                            </Grid> */}
                            <Grid item xs={12}>
                                <BiztranControlsFormik
                                    control='select'
                                    type='text'
                                    label='Category'
                                    name='CategoryID'
                                    options={Categorycmb}
                                    onChange={(e) => setCategoryID(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <BiztranControlsFormik
                                    control='select'
                                    type='text'
                                    label='Hotel Star Rating'
                                    name='HotelStarRatingID'
                                    options={HotelStarRatingcmb}
                                    onChange={(e) => setHotelStarRatingID(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <BiztranControlsFormik
                                    control='input'
                                    type='text'
                                    label='Upper Ceiling Capital Cities'
                                    name='UpperCeilingCapitalCities'
                                    onChange={(e) => setUpperCeilingCapitalCities(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <BiztranControlsFormik
                                    control='input'
                                    type='text'
                                    label='Upper Ceiling Non Capital Cities'
                                    name='UpperCeilingNonCapitalCities'
                                    onChange={(e) => setUpperCeilingNonCapitalCities(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <div style={{ width: '100%' }}>
                                    <div style={{ display: 'flex', justifyContent: 'center', alignContent: "center" }}>
                                        <BiztranControls.Button
                                            text="SAVE"
                                            type="submit"
                                            startIcon={<SaveIcon />}
                                        />
                                        <BiztranControls.Button
                                            text="CLOSE"
                                            startIcon={<CloseIcon />}
                                            onClick={() => { props.setOpen(false); }}
                                        />
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                    </Form>
                }}
            </Formik>
        </div>
    );
}

export default CreateHotelStayPolicy;
